import { RootState } from '@/App/store';

export const selectAppInfoInitialized = (state: RootState) => state.info.initialized;
